import { useState, useEffect } from 'react';
import { LogOut } from 'lucide-react';

export function ImpersonationBanner() {
  const [impersonating, setImpersonating] = useState<string | null>(null);

  useEffect(() => {
    setImpersonating(localStorage.getItem('impersonating'));
  }, []);

  if (!impersonating) return null;

  const handleStopImpersonating = () => {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      localStorage.setItem('token', adminToken);
      localStorage.removeItem('admin_token');
    }
    localStorage.removeItem('impersonating');
    window.location.href = '/app/admin';
  };

  return (
    <div className="bg-warning text-warning-foreground px-4 py-2 flex items-center justify-between text-sm" style={{ backgroundColor: '#f59e0b', color: '#000' }}>
      <span className="font-medium">
        Impersonating: {impersonating}
      </span>
      <button
        onClick={handleStopImpersonating}
        className="flex items-center gap-1.5 px-3 py-1 rounded-md font-medium hover:opacity-80 transition-opacity"
        style={{ backgroundColor: 'rgba(0,0,0,0.15)' }}
      >
        <LogOut className="w-3.5 h-3.5" />
        Stop Impersonating
      </button>
    </div>
  );
}
